module.exports = __webpack_public_path__ + "img/registration success_TCN.f65b04d7.png";